import React from "react";
import classNames from "classnames";

interface BadgeProps {
    value?: number;
    max?: number;
    showzero?: boolean;
    dot?: boolean;
    overlapCircle?: boolean;
    anim?: boolean;
    className?: string;
    color?: "" | "primary" | "secondary" | "danger";
    position?: "top-start" | "top-end" | "bottom-start" | "bottom-end";
    children?: any;
    [x: string]: any;
}

export const Badge = ({ value, max, showzero, dot, overlapCircle, anim, className, color, position, children, ...props }: BadgeProps) => {
    if (!position) position = "top-end";
    //if (!color) color = "primary";

    var cnBadge = classNames("badge", className, "badge-" + position, {
        "bg-primary": color === "primary",
        "bg-secondary": color === "secondary",
        "bg-danger": color === "danger",

        "text-primary": dot && color === "primary",
        "text-secondary": dot && color === "secondary",
        "text-danger": dot && color === "danger",

        "d-none": !value && !showzero && !dot,
        "badge-dot": !!dot,
        "badge-overlap-circle": overlapCircle,
        "badge-anim": !!anim,
    });

    var args = !dot || !color || !color.startsWith("#") ? {} : { color: color };
    var content = value > max ? "+" + max : value;
    if (!children) {
        return <span className={cnBadge}>{content}</span>;
    } else {
        return (
            <span className="badge-root" {...props}>
                {children}
                <span className={cnBadge} {...args}>
                    {!dot && content}
                </span>
            </span>
        );
    }
};

function hexColorToStyle(color, text, bg) {
    if (!color || !color.startsWith("#")) return {};
    var style = text ? { color: color } : {};
    return !bg ? style : { ...style, backgroundColor: color };
}
